import * as apicall from "../components/Apicall";

const qs = (params = {}) => {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  );
  const search = new URLSearchParams(clean).toString();
  return search ? `?${search}` : "";
};

/* ---------------------------------------------------------------- *
 *  Categories
 * ---------------------------------------------------------------- */
export const getCategories = (filters = {}) => apicall.get(`finance/opex/categories${qs(filters)}`);
export const createCategory = (name) => apicall.post({ name }, "finance/opex/categories");
export const updateCategory = (id, name) => apicall.post({ name }, `finance/opex/categories/${id}`);
export const setCategoryStatus = (id, status) => apicall.post({ status }, `finance/opex/categories/${id}/status`);

/* ---------------------------------------------------------------- *
 *  Items (expense definitions)
 * ---------------------------------------------------------------- */
export const getItems = (filters = {}) => apicall.get(`finance/opex/items${qs(filters)}`);
export const createItem = (data) => apicall.post(data, "finance/opex/items");
export const updateItem = (id, data) => apicall.post(data, `finance/opex/items/${id}`);
export const setItemStatus = (id, status) => apicall.post({ status }, `finance/opex/items/${id}/status`);

/* ---------------------------------------------------------------- *
 *  Dashboard reminders
 * ---------------------------------------------------------------- */
export const getReminders = () => apicall.get("finance/opex/reminders");

/* ---------------------------------------------------------------- *
 *  Payments (record + history)
 * ---------------------------------------------------------------- */
export const recordPayment = (itemId, data) => apicall.post(data, `finance/opex/items/${itemId}/payments`);
export const getPayments = (filters = {}) => apicall.get(`finance/opex/payments${qs(filters)}`);
